import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './SolarIPP.css';
import { useNavigate } from 'react-router-dom';


// Importing images from assets/Project
import image1 from '../../assets/Project/Project1/Img1.png';
import image2 from '../../assets/Project/Project1/Image1.png';
import image3 from '../../assets/Project/Project1/Image2.png';
import image4 from '../../assets/Project/Project1/Image3.png';
import CustomButton from '../Button/CustomButton';
import pro2 from '../../assets/Project/image2.png';
import pro3 from '../../assets/Project/image3.png';
import pro4 from '../../assets/Project/image4.png';

const SolarIPP = () => {
    const navigate = useNavigate();
    return (
        <div className="solar-ipp-page">
            {/* Hero Section */}
            <section className="solar-ipp-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 hero-text-col">
                            <h1 className="hero-title">Solar IPP – Ground Mounted Project</h1>
                            <h3 className="hero-location">Gaya, Bihar</h3>
                            <p className="hero-description">
                                This 6 MW AC ground-mounted solar project was developed under the PM KUSUM Scheme in Gaya, Bihar.
                                The plant was built to generate clean and reliable power while supporting rural energy needs in the region.
                            </p>
                            <CustomButton
                variant="white"
                size="lg"
                text=" Discuss Your Project"
                onClick={() => navigate("/contact")}
              />
                        </div>
                        <div className="col-lg-6 hero-image-col">
                            <img src={image1} alt="Solar Engineer on Ladder" className="hero-img img-fluid" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Main Content Section */}
            <main className="solar-ipp-content">
                <div className="container">
                    {/* Project Overview */}
                    <section className="content-section">
                        <h2>PROJECT OVERVIEW</h2>
                        <p>
                            This project was developed as part of India's renewable energy mission.
                            The plant is spread across open land in Gaya district and designed for long-term performance. The objective was clear — generate stable solar power and contribute to local grid stability.
                            From the early planning stage to final installation, careful coordination helped ensure smooth progress.
                        </p>
                    </section>

                    {/* Our Role */}
                    <section className="content-section">
                        <h2>OUR ROLE IN THIS PROJECT</h2>
                        <p>In this IPP project, our team supported execution and coordination activities.</p>
                        <p>Our involvement included:</p>
                        <ul>
                            <li>Coordinating between developers and EPC teams</li>
                            <li>Monitoring construction progress</li>
                            <li>Reviewing timelines and milestones</li>
                            <li>Ensuring safety practices at the site</li>
                            <li>Supporting quality checks during installation</li>
                        </ul>
                    </section>

                    {/* Project Highlights */}
                    <section className="content-section">
                        <h2>PROJECT HIGHLIGHTS</h2>
                        <ul>
                            <li>6 MW AC ground-mounted solar plant</li>
                            <li>Developed under PM KUSUM Scheme</li>
                            <li>Located in Gaya, Bihar</li>
                            <li>Designed for reliable and long-term power generation</li>
                        </ul>
                    </section>

                    {/* Execution Approach */}
                    <section className="content-section">
                        <h2>EXECUTION APPROACH</h2>
                        <ul>
                            <li>Land preparation</li>
                            <li>Structure installation</li>
                            <li>Solar panel mounting</li>
                        </ul>
                    </section>

                    {/* Impact of the Project */}
                    <section className="content-section child-impact">
                        <h2>IMPACT OF THE PROJECT</h2>
                        <ul>
                            <li>This solar plant contributes clean electricity to the grid and supports India's renewable energy goals.</li>
                            <li>It helps reduce dependence on traditional power sources and supports rural development initiatives.</li>
                            <li>The project stands as a practical example of how structured planning and coordination can deliver dependable clean energy.</li>
                        </ul>
                    </section>

                    {/* Image Grid */}
                    <section className="image-grid-section">
                        <div className="row image-grid">
                            <div className="col-md-6 grid-item">
                                <img src={image2} alt="Solar Field" className="img-fluid grid-img" />
                            </div>
                            <div className="col-md-6 grid-item">
                                <img src={image3} alt="Solar Panels Construction" className="img-fluid grid-img" />
                            </div>
                            <div className="col-md-6 grid-item mt-4 mt-md-0 pt-md-4">
                                <img src={image4} alt="Solar Panels and Clouds" className="img-fluid grid-img" />
                            </div>
                            <div className="col-md-6 grid-item mt-4 mt-md-0 pt-md-4">
                                <img src={image1} alt="Solar Engineers Inspecting" className="img-fluid grid-img" />
                            </div>
                        </div>
                    </section>

                    {/* Explore More Projects */}
                    <section className="explore-more-section">
                        <h2 className="explore-title">Explore More Renewable Energy Projects</h2>
                        <div className="row">
                            {/* Card 1 */}
                            <div className="col-md-4 mb-4">
                                <Link to="/projects/solar-epc" className="text-decoration-none">
                                    <div className="project-card">
                                        <img src={pro2} alt="Solar EPC" className="card-img-top" />
                                        <div className="card-body">
                                            <h5 className="card-title">Solar EPC,<br />Madhubani, Bihar</h5>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            {/* Card 2 */}
                            <div className="col-md-4 mb-4">
                                <Link to="/projects/solar-hybrid" className="text-decoration-none">
                                    <div className="project-card">
                                        <img src={pro3} alt="Solar Hybrid EPC" className="card-img-top" />
                                        <div className="card-body">
                                            <h5 className="card-title">Solar Hybrid EPC, Pusa,<br />Samastipur, Bihar</h5>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            {/* Card 3 */}
                            <div className="col-md-4 mb-4">
                                <Link to="/projects/solar-bess" className="text-decoration-none">
                                    <div className="project-card">
                                        <img src={pro4} alt="Solar + BESS EPC" className="card-img-top" />
                                        <div className="card-body">
                                            <h5 className="card-title">Solar + BESS EPC<br />Tamil Nadu</h5>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </section>
                </div>
            </main>
        </div>
    );
};

export default SolarIPP;
